<template>
  <div class="renwu">
    <!-- 医生工作量统计 -->
    <div class="top">
      <Input @on-clear="getDoctor(1, 1)" @on-enter="getDoctor(1, 1)" v-model.trim="doctorName" placeholder="请输入医生名称进行搜索" class="journal-input" clearable>
      <Icon type="ios-search" slot="prefix" />
      </Input>
      <Date-picker @on-change="datePicker" :options="options2" class="data" type="daterange" placeholder="选择日期"></Date-picker>
    </div>
    <div class="table-cont">
      <Table @on-sort-change="changesort" stripe :columns="columns" :data="data"></Table>
    </div>
    <!-- <div class="page-div">
      <Page :total="obj.total" @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div> -->
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <Modal class="ivumodal" footer-hide width="800" v-model="seeShow" title="问诊详情">
      <Table stripe :columns="columns2" :data="data2"></Table>
      <!-- <div class="page-divs2">
        <Page :total="obj2.total" @on-page-size-change="changepeoplepage2" @on-change="changePeoplecurrent2" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
      </div> -->
      <div style="clear:both;"></div>
    </Modal>
  </div>
</template>
<script>
import { getDoctor, getAdvisoryList } from "../servers/api";
export default {
  name: "renwu",
  data() {
    return {
      seeShow: false,
      columns2: [
        {
          title: "体检者",
          key: "patientName",
          width: 130,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "性别",
          key: "patientSex",
          width: 130,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "订单接诊时间",
          key: "startTime",
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "咨询类型",
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "advisoryType",
          render: (h, params) => {
            let name = "";
            if (params.row.advisoryType == 0) {
              name = "报告解读";
            } else if (params.row.advisoryType == 1) {
              name = "既往病史问诊";
            } else if (params.row.advisoryType == 2) {
              name = "定制服务";
            }
            return h(
              "div",
              {
                style: {
                  "font-size": "13px",
                },
              },
              name
            );
          },
        },
      ],
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      data: [],
      data2: [],
      background: "#fff",
      columns: [
        {
          title: "医生",
          align: "center",
          key: "doctorName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "性别",
          width: 200,
          align: "center",
          ellipsis: true,
          sortable: true,
          key: "gender",
          render: (h, params) => {
            let name = "";
            if (params.row.gender == 1) {
              name = "男";
            } else if (params.row.gender == 2) {
              name = "女";
            }
            return h(
              "div",
              {
                style: {
                  "font-size": "13px",
                },
              },
              name
            );
          },
        },
        {
          title: "科室",
          align: "center",
          key: "departName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "职称",
          align: "center",
          key: "docExpertise",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "机构",
          align: "center",
          key: "organizationName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "已接诊次数",
          align: "center",
          key: "receiveNum",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "操作",
          key: "awssd",
          align: "center",
          width: 110,
          fixed: "right",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  height: "28px",
                  "line-height": "28px",
                  "text-align": "center",
                  "font-size": "13px",
                  border: "1px solid #53CAC3",
                  "border-radius": "5px",
                  width: "50px",
                  "margin-left": "15px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.toChakan(params.row);
                  },
                },
              },
              "查看"
            );
          },
        },
      ],
      current: 1,
      pageSize: 20,
      options2: {
        shortcuts: [
          {
            text: "最近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: "最近一个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: "最近三个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
      seeShow: false,
      orderField: "",
      isAsc: "",
      obj: {},
      startDate: "",
      endDate: "",
      name: "",
      doctorName: "",
    };
  },

  methods: {
    toChakan(row) {
      this.seeShow = true;
      let params = {
        startDate: this.startDate,
        endDate: this.endDate,
        dockorAccountId: row.doctorId,
      };
      getAdvisoryList(params).then((res) => {
        if (res.data.code == 1) {
          this.data2 = res.data.data;
        }
      });
    },
    datePicker(data) {
      //预约时间搜索
      this.startDate = data[0];
      this.endDate = data[1];
      this.orderField = "";
      this.isAsc = "";
      this.getDoctor(1);
    },
    getDoctor(index, num) {
      //列表
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      let params = {
        /* pageNum: this.current,
        pageSize: this.pageSize, */
        startDate: this.startDate,
        endDate: this.endDate,
        doctorName: this.doctorName,
        /* orderField: this.orderField,
        isAsc: this.isAsc, */
      };
      getDoctor(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.obj = res.data.data;
          this.data = res.data.data;
          /* this.data = res.data.data.list || []; */
        }
      });
    },
    changePeoplecurrent(num) {
      //换页
      this.current = num;
      this.getDoctor();
    },
    changepeoplepage(num) {
      //换每页请求多少条
      this.pageSize = num;
      this.getDoctor(1);
    },
    changesort(item) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.current = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.getDoctor(1);
    },
  },
  created() {
    this.getDoctor();
  },
  components: {},
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.renwu {
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .select {
    width: 130px;
    margin-right: 10px;
  }
  .journal-input {
    width: 200px;
    vertical-align: top;
  }
  .data {
    width: 250px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 15px;
    margin: 40px 0 60px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/jianhou/doctorworktongji.vue